<div class="welcome-wizard-page">
  <!-- Contenu affiché une fois qu'on sait que installation === 1 (loader Monicase affiché via LoaderService pendant la vérification) -->
  <div class="wizard-grid" *ngIf="!checkingInstallation">
    <!-- Colonne gauche : intro (étape 0) bg-primary, stepper (étape 1+) ou succès bg-white -->
    <div class="wizard-invitation-col" [ngClass]="(activeIndex === 0 && !configurationSaved) ? 'bg-primary' : 'bg-white'">
      <div class="wizard-logo">
        <img *ngIf="activeIndex === 0 && !configurationSaved" src="assets/images/logo/logo-monicase-light.png" class="logo" alt="MONICASE" />
        <img *ngIf="activeIndex >= 1 || configurationSaved" src="assets/images/logo/logo-monicase.png" class="logo" alt="MONICASE" />
      </div>

      <!-- Étape 0 : écran d'accueil -->
      <div *ngIf="activeIndex === 0 && !configurationSaved" class="wizard-intro-content">
        <h1 class="text-white font-bold text-6xl">Vous êtes à quelques clics de personnaliser votre MONICASE</h1>
        <p class="text-white text-lg">
          Lancez la configuration initiale et adaptez votre application à l'image de votre entreprise.
        </p>
      </div>

      <!-- Après enregistrement : message de succès -->
      <div *ngIf="configurationSaved" class="wizard-success-content">
        <div class="wizard-success-icon">
          <i class="fa-light fa-check"></i>
        </div>
        <h1 class="wizard-success-title">Configuration enregistrée</h1>
        <p class="wizard-success-text">
          Votre application est prête. Choisissez une action pour continuer.
        </p>
      </div>

      <!-- Stepper plat : 1. Identité administrative, 2. Coordonnées, 3. Identité graphique -->
      <div *ngIf="activeIndex >= 1 && !configurationSaved" class="wizard-vertical-stepper">
        <div *ngFor="let item of stepperItems" class="stepper-main-item"
             [class.completed]="isStepperCompleted(item.flatIndex)"
             [class.active]="isStepperCurrent(item.flatIndex)"
             [class.upcoming]="isStepperUpcoming(item.flatIndex)">
          <div class="stepper-main-row">
            <div class="stepper-circle">
              <i *ngIf="isStepperCompleted(item.flatIndex)" class="fa-light fa-check"></i>
              <span *ngIf="!isStepperCompleted(item.flatIndex)">{{ item.stepNumber }}</span>
            </div>
            <span class="stepper-main-label">{{ item.label }}</span>
            <i *ngIf="isStepperCurrent(item.flatIndex)" class="fa-light fa-chevron-right stepper-sub-arrow"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Colonne droite : contenu des étapes -->
    <div class="wizard-steps-col">
      <!-- Après enregistrement : options de suite -->
      <div *ngIf="configurationSaved" class="wizard-step wizard-next-steps">
        <h3 class="mb-4">Que souhaitez-vous faire maintenant ?</h3>
        <div class="wizard-next-steps-grid">
          <a [routerLink]="['/moni', 'clients', 'nouveau']" class="wizard-next-step-card">
            <i class="fa-light fa-users wizard-next-step-icon"></i>
            <span class="wizard-next-step-label">Créer mon premier client</span>
            <i class="fa-light fa-arrow-right wizard-next-step-arrow"></i>
          </a>
          <a [routerLink]="['/moni', 'produits', 'nouveau']" class="wizard-next-step-card">
            <i class="fa-light fa-box wizard-next-step-icon"></i>
            <span class="wizard-next-step-label">Créer mon premier produit</span>
            <i class="fa-light fa-arrow-right wizard-next-step-arrow"></i>
          </a>
          <a [routerLink]="['/moni', 'devis', 'nouveau']" class="wizard-next-step-card">
            <i class="fa-light fa-file-edit wizard-next-step-icon"></i>
            <span class="wizard-next-step-label">Créer mon premier devis</span>
            <i class="fa-light fa-arrow-right wizard-next-step-arrow"></i>
          </a>
          <a [routerLink]="['/moni', 'factures', 'nouveau']" class="wizard-next-step-card">
            <i class="fa-light fa-file wizard-next-step-icon"></i>
            <span class="wizard-next-step-label">Créer ma première facture</span>
            <i class="fa-light fa-arrow-right wizard-next-step-arrow"></i>
          </a>
          <a [routerLink]="['/moni', 'dashboard']" class="wizard-next-step-card wizard-next-step-card-secondary">
            <i class="fa-light fa-compass wizard-next-step-icon"></i>
            <span class="wizard-next-step-label">Parcourir Monicase</span>
            <i class="fa-light fa-arrow-right wizard-next-step-arrow"></i>
          </a>
        </div>
      </div>

      <!-- Étape 0 : texte + bouton Commencer -->
      <div *ngIf="activeIndex === 0 && !configurationSaved" class="wizard-step wizard-step-intro">
        <h3>Configuration de votre application</h3>
        <p class="text-600 mb-4">
          Cette personnalisation permettra de renseigner&nbsp;:
        </p>
        <ul class="personalization-list mb-4">
          <li>Identité administrative</li>
          <li>Coordonnées</li>
          <li>Identité graphique</li>
        </ul>
        <p class="text-500 mb-4">
          Ces informations apparaîtront automatiquement sur vos documents générés par MONICASE.
        </p>
        <button
          pButton
          type="button"
          label="Commencer la personnalisation"
          icon="fa-light fa-arrow-right"
          iconPos="right"
          (click)="startWizard()"
        ></button>
      </div>

      <!-- Sous-étapes : un groupe à la fois -->
      <ng-container *ngIf="activeIndex >= 1 && !configurationSaved && currentSubStep">
        <div class="wizard-step">
          <p-card [header]="currentSubStep.groupLabel" styleClass="wizard-card-no-bg">
            <div class="wizard-group">
              <div class="grid p-fluid">
                <ng-container *ngFor="let field of currentSubStep.group.fields">
                  <div class="col-12" [class.md:col-6]="field.type !== 'textarea'">
                    <div *ngIf="field.type === 'text'" class="field-wrapper">
                      <label [for]="'wz-' + field.name">{{ field.label }}<span *ngIf="field.required" class="text-red-500"> *</span></label>
                      <input
                        type="text"
                        [id]="'wz-' + field.name"
                        pInputText
                        class="w-full"
                        [(ngModel)]="formValues[field.name]"
                        [placeholder]="field.label"
                      />
                    </div>
                    <div *ngIf="field.type === 'number'" class="field-wrapper">
                      <label [for]="'wz-' + field.name">{{ field.label }}<span *ngIf="field.required" class="text-red-500"> *</span></label>
                      <p-inputNumber
                        [id]="'wz-' + field.name"
                        [(ngModel)]="formValues[field.name]"
                        [placeholder]="field.label"
                        mode="decimal"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="2"
                        class="w-full"
                        inputStyleClass="w-full"
                      ></p-inputNumber>
                    </div>
                    <div *ngIf="field.type === 'textarea'" class="field-wrapper">
                      <label [for]="'wz-' + field.name">{{ field.label }}<span *ngIf="field.required" class="text-red-500"> *</span></label>
                      <textarea
                        [id]="'wz-' + field.name"
                        pInputTextarea
                        class="w-full"
                        rows="3"
                        [(ngModel)]="formValues[field.name]"
                        [placeholder]="field.label"
                      ></textarea>
                    </div>
                    <div *ngIf="field.type === 'image'" class="field-wrapper wizard-image-field">
                      <input
                        type="file"
                        [id]="'wz-file-' + field.name"
                        accept="image/*"
                        (change)="onImageFileChange($event, field)"
                        class="hidden"
                      />
                      <div class="wizard-image-field-layout">
                        <div class="wizard-image-preview-box">
                          <label [attr.for]="imageCompressing ? null : 'wz-file-' + field.name"
                                 class="wizard-image-upload-trigger"
                                 [class.wizard-image-upload-trigger-disabled]="imageCompressing"
                                 title="Choisir une image">
                            <i class="fa-light fa-upload"></i>
                          </label>
                          <img *ngIf="getImagePreview(field.name)" [src]="getImagePreview(field.name)" alt="Aperçu du logo" class="wizard-image-preview" />
                          <div *ngIf="!getImagePreview(field.name) && !imageCompressing" class="wizard-image-placeholder"></div>
                          <div *ngIf="!getImagePreview(field.name) && imageCompressing" class="wizard-image-placeholder wizard-image-placeholder-loading">
                            <span>Chargement...</span>
                          </div>
                        </div>
                        <div class="wizard-image-description-block">
                          <p class="wizard-image-instruction">Chargez votre logo en cliquant sur l'icône en haut à gauche de l'aperçu.</p>
                          <p class="wizard-image-description">
                            Ce logo sera utilisé pour les devis, les factures mais aussi pour les emails envoyés à partir de MONICASE.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </p-card>
        </div>

        <div class="wizard-actions flex justify-content-between mt-4">
          <div>
            <button
              *ngIf="activeIndex > 0"
              pButton
              type="button"
              label="Précédent"
              icon="fa-light fa-arrow-left"
              class="p-button-text"
              (click)="prev()"
            ></button>
          </div>
          <div class="flex gap-2">
            <button
              *ngIf="activeIndex < totalSteps"
              pButton
              type="button"
              label="Suivant"
              icon="fa-light fa-arrow-right"
              iconPos="right"
              [disabled]="!isCurrentStepValid()"
              (click)="next()"
            ></button>
            <button
              *ngIf="activeIndex === totalSteps"
              pButton
              type="button"
              label="Terminer la configuration"
              icon="fa-light fa-check"
              [loading]="saving"
              [disabled]="!isCurrentStepValid()"
              (click)="saveAndFinish()"
            ></button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
